export const inputStyle = {
  border: "1px",
  height: "38px",
  borderRadius: "10px",
  background: "#F0F0F0",
  padding: "5px 0 5px 10px",
  fontSize: "18px",
  fontWeight: "400",
  marginTop: 5,
  marginBottom: 5,
};

export const selectStyle = {
  border: "0px",
  height: "38px",
  borderRadius: "10px",
  background: "#F0F0F0",
  padding: 0,
  fontSize: "16px",
  fontWeight: "400",
  marginTop: 5,
  marginBottom: 5,
};

export const h3Style = {
  fontFamily: "SofiaPro",
  fontWeight: "700",
  fontSize: "24px",
  color: "#161728",
  marginBottom: "6px",
};

export const style = {
  bgcolor: "background.paper",
  p: 2,
  px: 4,
  pb: 3,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "white",
  borderRadius: "20px",
  width: "193px",
  height: "212px",
};

export const tagStyle = {
  backgroundColor: "#F0F0F0",
  height: "34px",
  borderRadius: 10,
  borderWidth: 0,
  marginLeft: 3,
  marginRight: 3,
  color: '#5C5D68'
};

export const tagIconstyle = {
  color: "#5C5D68",
  fontSize: '1.2em',
  stroke: "#5C5D68",
  strokeWidth: 2,
}

